var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 70 142 10",
    width: 142,
    height: 118,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "#fff",
    fillRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.732 70.822l-70.866-7.295L0 70.822l70.866 46.343 70.866-46.343z",
    fill: "#fcbf92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 70.822l70.866 17.705v28.638L0 87.482v-16.66z",
    fill: "#9d5025"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.732 70.822L70.866 88.526v28.638l70.866-29.683v-16.66z",
    fill: "#f58534"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15 45.647H0v16.835l9.15 1.393 10.171-9.018-10.17-9.21z",
    fill: "#9d5025"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.322 63.179l-10.172.696V45.647h10.171V63.18z",
    fill: "#f58534"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.179 24.652l-12.047 1.897v38.196l12.047 2.09 11.026-21.188-11.026-20.995z",
    fill: "#9d5025"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.205 65.79l-11.026 1.045V24.652l11.026 1.044V65.79z",
    fill: "#f58534"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.669 33.148L33.036 34.54v33.496l16.633 2.785 17.654-18.924-17.654-18.75z",
    fill: "#9d5025"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.882 69.255L49.67 70.82V33.148l11.213.696v35.41z",
    fill: "#f58534"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9d5025"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.866 2.768l-11.213 2.96v66.66l11.213 1.898L82.08 38.527 70.866 2.768z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.246 69.255l10.818 1.567 16.632-25.175-16.632-25-10.818 1.393v47.215z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.696 45.647l-16.632-25-10.818 1.393"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.32 65.79l11.233 1.045 12.048-31.772-12.048-31.599-11.234 2.264V65.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.41 63.179l10.172.696 9.15-31.424L132.582 0l-10.171 2.09v61.089z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.866 2.768l11.214 2.96v66.66l-11.214 1.898V2.768zm37.83 20.665l-16.632-2.785v50.174l16.632-2.786V23.433zm18.905-15.964l-12.048-4.005v63.37l12.048-2.089V7.47zm14.131-3.656L132.582 0v63.875l9.15-1.393V3.812z",
    fill: "#f58534"
  })));
}

export default SvgIcon;